module.exports = __webpack_public_path__ + "img/xls.a67e3783.svg";